import React from 'react';

function Footer() {
    return (
        <footer className="footer">
            <div className="section-content">
                <h3 className="footer-title">
                    Hospitality is art. <span className="highlight">Warp Mill</span> makes it operational.
                </h3>
                <p className="footer-tagline">
                    <span className="highlight">One Partner</span>. Every System. <span className="highlight">Complete Control</span>.
                </p>
                <p className="footer-contact">
                    Built in Houston, TX | info@warpmill.com | +1 346 266 1977
                </p>
                <p className="footer-copyright">
                    © 2025 WarpMill Technologies. All rights reserved.
                </p>
            </div>
        </footer>
    );
}

export default Footer;
